import { render, staticRenderFns } from "./ModernMultiversalDimensionRow.vue?vue&type=template&id=32da9d66&scoped=true&"
import script from "./ModernMultiversalDimensionRow.vue?vue&type=script&lang=js&"
export * from "./ModernMultiversalDimensionRow.vue?vue&type=script&lang=js&"
import style0 from "./ModernMultiversalDimensionRow.vue?vue&type=style&index=0&id=32da9d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32da9d66",
  null
  
)

export default component.exports